// Lädt die gepflegte Bestandsliste (bestand.xlsx) zur Laufzeit aus dem
// Webroot (Strato: einfach per FTP übers Hauptsverzeichnis legen — der Shop
// liest sie beim nächsten Laden der Shop-Seite frisch, ohne Rebuild).
// Schlägt das Lesen fehl, greift der eingebaute Datenstand.
import { PRICE_GROUPS, PRICE_STAND } from "@/data/priceList";
import { SHOP_IMAGES } from "@/data/shopImages";

const AUTO_HASH_RE = /^\/produkte\/shop\/(k[0-9a-f]{10}|jultec-[a-z0-9._-]+|kathrein-[a-z0-9._-]+)\.webp$/; // automatisch erzeugt (Katalog-Crop / Jultec / Kathrein)

function parsePrice(v) {
    if (v === null || v === undefined || v === "") throw new Error("Preis fehlt");
    if (typeof v === "number") return Math.round(v * 100);
    let s = String(v).replace(/€/g, "").replace(/EUR/gi, "").replace(/\s/g, "");
    if (s.includes(",") && s.includes(".")) s = s.replace(/\./g, "").replace(",", ".");
    else s = s.replace(",", ".");
    const f = parseFloat(s);
    if (Number.isNaN(f)) throw new Error(`Ungültiger Preis: ${v}`);
    return Math.round(f * 100);
}

function parseSku(v) {
    const s = String(v).trim();
    if (/^\d{1,6}$/.test(s)) return s.padStart(6, "0");
    throw new Error(`Ungültige Art.-Nr.: ${v}`);
}

export function bundled() {
    return { groups: PRICE_GROUPS, stand: PRICE_STAND, images: SHOP_IMAGES, quelle: "eingebacken" };
}

export async function loadBestand() {
    try {
        const res = await fetch("/bestand.xlsx?t=" + Date.now(), { cache: "no-store" });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const buf = await res.arrayBuffer();
        const XLSX = await import("xlsx");
        const wb = XLSX.read(buf, { type: "array" });
        const ws = wb.Sheets[wb.SheetNames[0]];
        const rows = XLSX.utils.sheet_to_json(ws, { header: 1, raw: true, defval: "" });

        // Kopfzeile finden (enthält „Art.-Nr."), Spalten über die Überschriften zuordnen
        const headIdx = rows.findIndex((r) => r && /art\.-?nr/i.test(String(r[0] || "")));
        if (headIdx < 0) throw new Error("Kopfzeile nicht gefunden");
        const head = rows[headIdx].map((h) => String(h || "").toLowerCase());
        const col = (re) => head.findIndex((h) => re.test(h));
        const cTyp = col(/typ/);
        const cName = col(/bezeichnung/);
        const cGruppe = col(/gruppe/);
        const cPreis = col(/preis/);
        const cBild = col(/produktbild|bild/);
        if (cName < 0 || cPreis < 0) throw new Error("Pflichtspalten fehlen");

        // Preisstand aus dem Hinweistext über der Tabelle („Stand: X —")
        let stand = PRICE_STAND;
        for (let i = 0; i < headIdx; i++) {
            const txt = String(rows[i]?.[0] || "");
            const m = txt.match(/Stand:\s*([^—\-]+?)\s*[—\-]/);
            if (m && m[1].trim()) { stand = m[1].trim(); break; }
        }

        const groups = [];
        const gidx = {};
        const images = { ...SHOP_IMAGES };
        const skus = new Set();
        for (let i = headIdx + 1; i < rows.length; i++) {
            const r = rows[i];
            if (!r || r[0] === "" || r[0] === null || r[0] === undefined) continue;
            const sku = parseSku(r[0]);
            if (skus.has(sku)) continue; // doppelte Art.-Nr.: erste Zeile gewinnt
            skus.add(sku);
            const ref = String(r[cTyp] ?? "").trim();
            const name = String(r[cName] ?? "").trim() || `Art.-Nr. ${sku} — Bezeichnung lt. Katalog`;
            const group = String(r[cGruppe] ?? "").trim() || "Sonstiges";
            const cents = parsePrice(r[cPreis]);
            if (!(group in gidx)) { gidx[group] = groups.length; groups.push({ title: group, items: [] }); }
            groups[gidx[group]].items.push({ sku, name, ref, price: cents });
            // Bildpflege: eigener Eintrag (kein Auto-Hash) gewinnt gegen eingebaute Bilder
            if (cBild >= 0) {
                const bild = String(r[cBild] ?? "").trim();
                if (bild && !AUTO_HASH_RE.test(bild)) {
                    images[sku] = bild.startsWith("/") || bild.startsWith("http") ? bild : `/produkte/shop/${bild}`;
                }
            }
        }
        if (groups.length === 0) throw new Error("Keine Artikel gefunden");
        return { groups, stand, images, quelle: "bestand.xlsx" };
    } catch (e) {
        console.warn("bestand.xlsx konnte nicht geladen werden — eingebaute Daten aktiv:", e);
        return { ...bundled(), quelle: "fallback" };
    }
}
